<app-base-today-statistics
[title]="title"
[getItemsApiMethodName]="getItemsApiMethodName"
[barChartId]="barChartId"
[doughnutChartId]="doughnutChartId"
>
</app-base-today-statistics>
